<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{pageTitle}}</div>
			<div class="content">
				<a-form>
					<a-row class="input-row">
						<a-col>
							<a-form-item
									:validate-status="isSubmit&&!formData.roleName?'error':''"
									:help="isSubmit&&!formData.roleName?'请输入角色名称，长度不能超过20字符':''"
							>
								<div class="name hospital-required">角色名称</div>
								<div>
									<a-input :disabled="formData.system" v-model="formData.roleName"
									         placeholder="请输入角色名称，长度不能超过20字符"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col>
							<a-form-item>
								<div class="name">角色描述</div>
								<div>
									<a-textarea
											:disabled="formData.system"
											placeholder="请输入角色描述，长度不能超过100字符"
											v-model="formData.remark"
											:autosize="{ minRows: 2, maxRows: 6 }"
									/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row v-if="menus.length>0" class="input-row">
						<a-col>
							<a-form-item>
								<div class="name">设置权限</div>
								<div>
									<a-tree
											checkable
											:disabled="formData.system"
											:autoExpandParent="autoExpandParent"
											v-model="treeKeys"
											@check="checkTree"
											:treeData="menus"
									/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col>
							<a-form-item>
								<div class="name">数据权限</div>
								<div>
									<a-radio-group :disabled="formData.system" @change="onChange"
									               v-model="formData.dataPermit">
										<a-radio :value="0">全部</a-radio>
										<a-radio :value="1">本机构</a-radio>
										<a-radio :value="2">本用户</a-radio>
										<a-radio :value="3">本机构+本用户</a-radio>
									</a-radio-group>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
				</a-form>
				<div class="confrim-footer" v-if="!formData.system">
					<a-button @click="submitClick" type="primary" class="cf-mr10">确定</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import {TreeSelect} from "ant-design-vue";

  const SHOW_PARENT = TreeSelect.SHOW_PARENT;
  export default {
    props: {
      roleData: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        data: [],
        formData: {
          roleName: "",
          remark: "",
          dataPermit: 1,
          checkedKeys: []
        },
        pageTitle: "新建角色",
        value: ["0-0-0"],
        SHOW_PARENT,
        autoExpandParent: true,
        menus: [],
        sameLevelMenus: [],
        isSubmit: false,
        treeKeys: {
          checked: [],
          halfChecked: []
        }
      };
    },
    components: {},
    created() {
      this.getMenus();
    },
    methods: {
      checkTree(key, e) {
        // this.formData.checkedKeys = key.checked;
        this.treeKeys = {
          checked: [],
          halfChecked: []
        };
        e.checkedNodes.map(item => {
          this.treeKeys.checked.push(item.data.props.id);
        });
        // e
        this.treeKeys.halfChecked = e.halfCheckedKeys;
        // this.treeKeys = key;
        // this.checkParent(key);
      },
      onChange(value) {
        this.value = value;
      },
      checkParent(key) {
        let ary = key.checked;
        let checkArys = ary.concat([]);
        let result = [];
        checkArys.forEach(key => {
          let current = this.sameLevelMenus.find(item => item.key == key);
          if (current) {
            // 向上选中
            this.findParent(result, current);
            // 向下选中
            //   this.findChild(result, current);
          }
        });
        this.formData.checkedKeys = result.concat([]);
      },
      findChild(result, item) {
        //   let isKey = result.find(s => s == item.key);
        //   if (!isKey) {
        //     result.push(item.key);
        //   }
        //   if (item.children && item.children.length > 0) {
        //     item.children.forEach(d => {
        //       this.findChild(result, d);
        //     });
        //   }
      },
      findParent(result, item) {
        let isKey = result.find(s => s == item.key);
        if (!isKey) {
          result.push(item.key);
        }
        let current = this.sameLevelMenus.find(d => d.id == item.parentId);
        if (current) {
          this.findParent(result, current);
        }
      },
      submitClick() {
        this.isSubmit = true;
        // this.formData.menuId = this.formData.checkedKeys.join(",");
        if (this.treeKeys.checked && this.treeKeys.checked.length > 0) {
          let ary = this.treeKeys.checked.concat(this.treeKeys.halfChecked);
          this.formData.menuId = ary.join(",");
        } else {
          this.formData.menuId = '';
        }
        this.formData.checkedKeys = this.formData.menuId ? this.formData.menuId.split(",") : [];
        // return;
        this.isSubmit = true;
        this.$nextTick(() => {
          const isPass =
            document.querySelectorAll(".ant-form-explain").length == 0;
          if (isPass) {
            if (this.roleData) {
              // 编辑
              this.$put("role", this.formData, true).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("修改角色成功");
                    this.$emit("close");
                  } else {
                    this.$message.error(res.data.message);
                  }
                },
                err => {
                  this.$message.error("添加角色失败，请稍后重试");
                }
              );
            } else {
              // 新增
              this.$post("role", this.formData, true).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("添加角色成功");
                    this.$emit("close");
                  } else {
                    this.$message.error(res.data.message);
                  }
                },
                err => {
                  this.$message.error("添加角色失败，请稍后重试");
                }
              );
            }
          }
        });
      },
      cancelSubmit() {
        this.$emit("close");
      },
      setMenusKeys(item) {
        item.key = item.id;
        let isItem = this.sameLevelMenus.find(d => d.id == item.id);
        if (!isItem) {
          this.sameLevelMenus.push(item);
        }
        if (item.children && item.children.length > 0) {
          let status = false;
          item.children.forEach(d => {
            let menuId = this.formData.checkedKeys.find(id => d.id == id);
            // if(d)
            if (menuId) {
              status = true;
            }
          });
          if (!status) {
            let menuId = this.formData.checkedKeys.find(id => item.id == id);
            if (menuId) {
              this.treeKeys.checked.push(item.id);
            }
          } else {
            this.treeKeys.halfChecked.push(item.id);
          }
          item.children.forEach(d => {
            this.setMenusKeys(d);
          });
        } else {
          let menuId = this.formData.checkedKeys.find(id => item.id == id);
          if (menuId) {
            this.treeKeys.checked.push(item.id);
          }
        }
      },
      getMenus() {
        this.$get("menu").then(res => {
          this.menus = res.data.rows.children;
          this.sameLevelMenus = [];
          if (this.roleData) {
            this.pageTitle = "编辑角色";
            this.formData = Object.assign(this.formData, this.roleData);
            if (this.roleData.menuId) {
              this.formData.checkedKeys = [];
              let result = [];
              JSON.parse(this.roleData.menuId).forEach(item => {
                result.push(item + "");
              });
              this.formData.checkedKeys = result;
              this.treeKeys = {
                checked: [],
                halfChecked: []
              };
              this.menus.forEach(item => {
                this.setMenusKeys(item);
              });
            }
          } else {
            this.pageTitle = "新建角色";
            this.treeKeys = {
              checked: [],
              halfChecked: []
            };
            this.menus.forEach(item => {
              this.setMenusKeys(item);
            });
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>